import { Card, CardActions, CardContent, CardMedia, Button, Typography, Dialog, DialogContent, DialogTitle, DialogActions } from "@mui/material"

import CreateQuizImg from '../../assets/images/quiz/create_quiz.png'
import StudentDashboardImg from '../../assets/images/quiz/student_dashboard.png'
import StudentFailImg from '../../assets/images/quiz/student_fail_quiz.png'
import StudentTakeQuizImg from '../../assets/images/quiz/student_take_quiz.png'
import TeacherDashboardImg from '../../assets/images/quiz/teacher_dashboard.png'
import TeacherResultImg from '../../assets/images/quiz/teacher_results.png'


const Quiz = ({ openQuiz, setOpenQuiz }) => {
  return (
    <>
      <Card sx={{ minWidth: 250, backgroundColor: '#18122B', margin: '1rem' }}>
        <CardMedia
          sx={{ height: 200 }}
          image={TeacherDashboardImg}
          title='Steganography'
        />
        <CardContent>
          <Typography variant='h6' textAlign='center' sx={{ color: '#EDEBF7' }}>
            <strong>Quiz</strong>
          </Typography>
        </CardContent>
        <CardActions sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center'
        }}>
          <Button
            sx={{
              color: '#EDEBF7',
              backgroundColor: '#443C68',
              '&:hover': {
                backgroundColor: '#393053'
              }
            }}
            variant="contained"
            onClick={() => setOpenQuiz(true)}
          >
            <strong>View More</strong>
          </Button>
        </CardActions>
      </Card>

      <Dialog
        fullWidth
        maxWidth='md'
        open={openQuiz}
        onClose={() => setOpenQuiz(false)}
      >
        <DialogTitle textAlign='center' sx={{ backgroundColor: "#18122B", color: '#EDEBF7' }}>
          Quiz
        </DialogTitle>
        <DialogContent sx={{ display: 'block', backgroundColor: "#18122B" }}>
          <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            margin: '2rem 0'
          }}>
            <img src={TeacherDashboardImg} alt='minesweeper' style={{
              maxWidth: '100%',
              width: 700,
              objectFit: 'contain'
            }} />
          </div>

          <Typography variant="body1" sx={{ color: '#EDEBF7' }}>
            Quiz is a full-stack web application that allows registered users to create or take quizzes. Users that are registered as teachers can create quizzes and check students results on published quizzes. Students can only take quizzes. They have 2 attempts per quiz and if they fail first time, they can retry after 24 hours. After finishing the quiz, they can view the results.
          </Typography>
          <Typography variant="body1" sx={{ color: '#EDEBF7', marginTop: '1rem' }} component='div'>
            Technologies used:
            <ul>
              <li>Javascript</li>
              <li>React.js</li>
              <li>Node.js</li>
              <li>Express.js</li>
              <li>MongoDB</li>
            </ul>
          </Typography>
          <Typography variant="h6" sx={{ color: '#EDEBF7', marginTop: '2rem' }}><strong>SCREENSHOTS</strong>:</Typography>
          <Typography variant="h6" sx={{ color: '#EDEBF7', marginTop: '1rem' }}><strong>Teacher</strong></Typography>

          <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            margin: '2rem 0'
          }}>
            <img src={TeacherDashboardImg} alt='minesweeper' style={{
              maxWidth: '100%',
              width: 700,
              objectFit: 'contain'
            }} />
          </div>

          <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            margin: '2rem 0'
          }}>
            <img src={CreateQuizImg} alt='minesweeper' style={{
              maxWidth: '100%',
              width: 700,
              objectFit: 'contain'
            }} />
          </div>

          <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            margin: '2rem 0'
          }}>
            <img src={TeacherResultImg} alt='minesweeper' style={{
              maxWidth: '100%',
              width: 700,
              objectFit: 'contain'
            }} />
          </div>

          <Typography variant="h6" sx={{ color: '#EDEBF7', marginTop: '1rem' }}><strong>Student</strong></Typography>

          <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            margin: '2rem 0'
          }}>
            <img src={StudentDashboardImg} alt='minesweeper' style={{
              maxWidth: '100%',
              width: 700,
              objectFit: 'contain'
            }} />
          </div>

          <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            margin: '2rem 0'
          }}>
            <img src={StudentTakeQuizImg} alt='minesweeper' style={{
              maxWidth: '100%',
              width: 700,
              objectFit: 'contain'
            }} />
          </div>

          <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            margin: '2rem 0'
          }}>
            <img src={StudentFailImg} alt='minesweeper' style={{
              maxWidth: '100%',
              width: 700,
              objectFit: 'contain'
            }} />
          </div>
          
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "#18122B" }}>
          <Button
            onClick={() => setOpenQuiz(false)}
            sx={{
              color: '#EDEBF7',
              backgroundColor: '#443C68',
              '&:hover': {
                backgroundColor: '#393053'
              }
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default Quiz